import { Accountant } from '../Model/Accountant';
import { Company } from '../Model/Company';
import { storeApi } from './storeApi';

export const accountantApi = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    authorizeAccountant: builder.query<any, { email: string; recaptcha: string }>({
      query: (arg) => {
        const { email, recaptcha } = arg;
        return {
          url: '/accountant/auth',
          method: 'POST',
          body: { email, captcha_response: recaptcha },
        };
      },
    }),
    getAccountantList: builder.query<Accountant[], Partial<Company>>({
      query: ({ _id }) => `/accountants/${_id}`,
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: 'Accountant', _id } as const)), { type: 'Accountant', id: 'LIST' }]
          : [{ type: 'Accountant', id: 'LIST' }],
    }),
    createAccountant: builder.mutation<Accountant, Partial<Accountant>>({
      query: ({ name, email, mobile, _id }) => ({
        url: `/accountant`,
        method: 'POST',
        body: { name, email, mobile, company_id: _id },
      }),
      invalidatesTags: [{ type: 'Accountant', id: 'LIST' }],
    }),
    updateAccountant: builder.mutation<Accountant, Partial<Accountant>>({
      query(data) {
        const { _id, ...body } = data;
        return {
          url: `/accountant/${_id}`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [{ type: 'Accountant', _id }],
    }),
    deleteAccountant: builder.mutation<Accountant, { companyId: string; accountantId: string }>({
      query({ companyId, accountantId }) {
        return {
          url: `/accountant/${companyId}/${accountantId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, accountantId) => [{ type: 'Accountant', accountantId }],
    }),
  }),
});

export const {
  useLazyAuthorizeAccountantQuery,
  useLazyGetAccountantListQuery,
  useCreateAccountantMutation,
  useDeleteAccountantMutation,
} = accountantApi;
